// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__2lNpk","file":"styles_file__3HCWY"};